import { timeToSeconds } from '@/utils/time';
import { SECONDS_IN_A_DAY } from './constants';
import { type SuiSelectListItemsAndGroupsValueType } from '@developers/scoro-ui';

export const isWithinMaxSecondsPerDay = (value: string) =>
	timeToSeconds(value) <= SECONDS_IN_A_DAY;

export const isUserListNotEmpty = (
	value: SuiSelectListItemsAndGroupsValueType
) => value.itemIds.length > 0;

export const getEarliestDate = (dates: string[]) => [...dates].sort()[0];

export const getLatestDate = (dates: string[]) =>
	[...dates].sort().reverse()[0];
